<script setup>

import axios from "axios";
import {computed, reactive, ref, watch} from "vue";
import {ElButton, ElCard, ElCol, ElMessage, ElRow, ElText} from "element-plus";
import { moneyTotal, formatMoney, roundMoney } from '../../../utils/money';

const props = defineProps({
    activity:Object,
    form:Object,
    itninery:Object,
    index: Number

});

const emit = defineEmits(['removeactivity']);
const ruleFormRef = ref()
let activity=props.activity;
const eform=props.form;
const itineries=props.itninery;
const editprice=ref(false);
const imageDialog=ref(false);
const imageIndex=ref(-1);
const imageDraft=ref('');
const MAX_ACTIVITY_IMAGES = 2;

const csrfToken = () => {
    const meta = document.querySelector('meta[name="csrf-token"]');
    if (meta && meta.getAttribute('content')) {
        return meta.getAttribute('content');
    }
    return (typeof window !== 'undefined' && window.csrf_token) ? window.csrf_token : '';
};

const uploadImageRequest = (options) => {
    const data = new FormData();
    data.append('file', options.file);
    return axios.post('/activityapi/uploadimage', data, {
        headers: {
            'Accept': 'application/json',
            'X-CSRF-TOKEN': csrfToken(),
        },
    }).then((response) => response.data);
};

const isUsableImage = (url) => {
    return typeof url === 'string'
        && url.trim() !== ''
        && url.toLowerCase().indexOf('noimage') === -1;
};

const imageList = computed(() => {
    let images = [];
    if (Array.isArray(activity.images) && activity.images.length) {
        images = activity.images;
    } else if (isUsableImage(activity.image)) {
        images = [activity.image];
    }
    return images.map((url) => (typeof url === 'string' ? url.trim() : '')).filter(isUsableImage).slice(0, MAX_ACTIVITY_IMAGES);
});

const applyImages = (urls) => {
    const next = urls.filter(isUsableImage).slice(0, MAX_ACTIVITY_IMAGES);
    activity.images = next;
    activity.image = next[0] || '';
};

const openImageEditor = (index) => {
    if (index < 0 && imageList.value.length >= MAX_ACTIVITY_IMAGES) {
        ElMessage({
            message: 'An activity can have at most 2 images.',
            type: 'warning',
        });
        return;
    }
    imageIndex.value = index;
    imageDraft.value = index >= 0 ? (imageList.value[index] || '') : '';
    imageDialog.value = true;
};

const saveImageDraft = () => {
    const url = imageDraft.value.trim();
    if (!url) {
        ElMessage({
            message: 'Upload an image or paste an image URL.',
            type: 'warning',
        });
        return;
    }
    if (!/^https?:\/\//i.test(url) && url.charAt(0) !== '/') {
        ElMessage({
            message: 'Image must be a valid URL.',
            type: 'warning',
        });
        return;
    }
    const next = imageList.value.slice();
    if (imageIndex.value >= 0) {
        next[imageIndex.value] = url;
    } else {
        if (next.length >= MAX_ACTIVITY_IMAGES) {
            ElMessage({
                message: 'An activity can have at most 2 images.',
                type: 'warning',
            });
            return;
        }
        next.push(url);
    }
    applyImages(next);
    imageDialog.value = false;
};

const removeImage = (index) => {
    const next = imageList.value.slice();
    next.splice(index, 1);
    applyImages(next);
};

const beforeImageUpload = (file) => {
    const allowed = ['image/jpeg', 'image/png', 'image/webp'];
    if (!allowed.includes(file.type)) {
        ElMessage({
            message: 'Upload a JPG, PNG, or WEBP image.',
            type: 'error',
        });
        return false;
    }
    if (file.size / 1024 / 1024 >= 5) {
        ElMessage({
            message: 'Image must be smaller than 5 MB.',
            type: 'error',
        });
        return false;
    }
    return true;
};

const onImageUploaded = (response) => {
    const url = response && response.url ? response.url : '';
    if (!url) {
        ElMessage({
            message: 'Image upload failed. Try again.',
            type: 'error',
        });
        return;
    }
    imageDraft.value = url;
};

const onImageUploadError = (error) => {
    const status = error && error.response ? error.response.status : (error && error.status);
    const fieldErrors = error && error.response && error.response.data && error.response.data.errors;
    let message = 'Image upload failed. Try again.';
    if (fieldErrors && fieldErrors.file && fieldErrors.file[0]) {
        message = fieldErrors.file[0];
    } else if (status === 419) {
        message = 'The page session expired. Refresh the page and upload again.';
    } else if (status === 413) {
        message = 'Image is too large. Use a file under 5 MB.';
    }
    ElMessage({
        message: message,
        type: 'error',
    });
};

const editform=reactive(
    {
        "pricing":{
            "total":activity.pricing.total,
            "adult":activity.pricing.adult ,
            "child":activity.pricing.child ,
            "infant":activity.pricing.infant ,
        }
    }
)

const removeactivity=(activity)=>{
    itineries.activities.splice(props.index, 1);
}


const refreshprice = () => {
    editform.pricing.total=activity.pricing.total;
    editform.pricing.adult=activity.pricing.adult;
    if(eform.childs>0){
        editform.pricing.child=activity.pricing.child;
    }
    if(eform.infants>0){
        editform.pricing.infant=activity.pricing.infant;
    }


};

watch(
    () => editform.pricing,
    () => {
        updateupricecount();
    },
    { deep: true }
)

const updateupricecount = () => {
    editform.pricing.total = moneyTotal(eform.adults, editform.pricing.adult, eform.childs, editform.pricing.child, eform.infants, editform.pricing.infant);
};

const savePrice = () => {
    let tprice={
        total:0,
        adult:0,
        infant:0,
        child:0
    };
    tprice.adult=roundMoney(editform.pricing.adult);
    tprice.child=eform.childs>0 ? roundMoney(editform.pricing.child) : 0;
    tprice.infant=eform.infants>0 ? roundMoney(editform.pricing.infant) : 0;
    tprice.total=moneyTotal(eform.adults, tprice.adult, eform.childs, tprice.child, eform.infants, tprice.infant);
    activity.pricing=tprice;
    editprice.value=false;
};

const submitForm = async (formEl) => {

    if (!formEl) return
    await formEl.validate((valid, fields) => {

        if (valid) {

            savePrice()

        }
    })
}
</script>

<template>
    <el-card class="mb-3"  shadow="never" :body-style="{padding:0}">
        <div class="flex">

            <div class="p-2" style="width: 100%;">
                <div>
                    <el-text tag="b" size="large">{{activity.name}}</el-text>
                </div>



            </div>
            <div class="p-2">
                <div class="flex">
                    <el-dropdown trigger="hover">
                        <div>
                            <el-text tag="b" size="large">₹{{ formatMoney(activity.pricing.total) }} </el-text>
                            <el-text class="ml-2" tag="b" size="small" type="info"  @click="refreshprice();editprice=true">Edit</el-text>
                        </div>
                        <template #dropdown>

                            <p >
                                Adult - ₹  {{formatMoney(activity.pricing.adult)}}
                            </p>
                            <p v-if="eform.childs>0">
                                Child - ₹  {{formatMoney(activity.pricing.child)}}
                            </p>
                            <p v-if="eform.infants>0">
                                Infant - ₹  {{formatMoney(activity.pricing.infant)}}
                            </p>

                        </template>
                    </el-dropdown>

                    <el-button class="ml-2" type="danger" size="small" @click="removeactivity(activity)" >Remove</el-button>
                </div>
                <div>

                </div>




            </div>
        </div>

        <div class="activity-images">
            <div class="activity-images-head">
                <el-text tag="b" size="small">Images ({{ imageList.length }}/2)</el-text>
            </div>
            <div class="activity-images-row">
                <div v-for="(url, imageIdx) in imageList" :key="imageIdx" class="activity-image-card">
                    <img :src="url" alt="" draggable="false" />
                    <div class="activity-image-actions">
                        <el-button size="small" @click="openImageEditor(imageIdx)">Edit</el-button>
                        <el-button size="small" type="danger" @click="removeImage(imageIdx)">Remove</el-button>
                    </div>
                </div>
                <el-button
                    v-if="imageList.length < 2"
                    size="small"
                    type="primary"
                    @click="openImageEditor(-1)"
                >Add Image</el-button>
            </div>
        </div>

    </el-card>

    <el-dialog
        v-model="editprice"
        title="Edit Pricing"
        width="50%"

    >
        <el-form
            ref="ruleFormRef"
            :model="editform"
            status-icon
            label-width="auto"
            class="demo-ruleForm"
            label-position="top"
            size="small"

        >
            <el-row :gutter="20">
                <el-col :span="4" >
                    <el-form-item label="Adults" >
                        <el-input v-model="eform.adults"  placeholder="Adults" readonly/>
                    </el-form-item>

                </el-col>
                <el-col :span="4" >
                    <el-form-item label="Adult Pricing" prop="pricing.adult" :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                        <el-input v-model="editform.pricing.adult"  placeholder="Adult Pricing" type="number" />
                    </el-form-item>

                </el-col>


            </el-row>
            <el-row :gutter="20" v-if="eform.childs>0">
                <el-col :span="4" >
                    <el-form-item label="Child" >
                        <el-input v-model="eform.childs"  placeholder="Child" readonly/>
                    </el-form-item>

                </el-col>
                <el-col :span="4" >
                    <el-form-item label="Child Pricing" prop="pricing.child" :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                        <el-input v-model="editform.pricing.child"  placeholder="Child Pricing"  type="number" />
                    </el-form-item>

                </el-col>


            </el-row>
            <el-row :gutter="20" v-if="eform.infants>0">
                <el-col :span="4" >
                    <el-form-item label="Infants" >
                        <el-input v-model="eform.infants"  placeholder="Infants" readonly/>
                    </el-form-item>

                </el-col>
                <el-col :span="4" >
                    <el-form-item label="Infants Pricing" prop="pricing.infant" :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                        <el-input v-model="editform.pricing.infant"  placeholder="Infants Pricing"  type="number"/>
                    </el-form-item>

                </el-col>


            </el-row>
            <el-row :gutter="20" >
                <el-col :span="4" >


                </el-col>
                <el-col :span="4" >
                    <el-form-item label="Total Pricing" prop="pricing.total" :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                        <el-input v-model="editform.pricing.total"  placeholder="Total Pricing"  type="number" readonly/>
                    </el-form-item>

                </el-col>


            </el-row>


        </el-form>


        <template #footer>
            <div class="dialog-footer">
                <el-button @click="editprice = false">Cancel</el-button>
                <el-button type="primary" @click="submitForm(ruleFormRef)">
                    Save
                </el-button>
            </div>
        </template>

    </el-dialog>

    <el-dialog
        v-model="imageDialog"
        :title="imageIndex >= 0 ? 'Edit Image' : 'Add Image'"
        width="50%"
    >
        <div v-if="imageDraft" class="activity-image-preview">
            <img :src="imageDraft" alt="" />
        </div>
        <el-upload
            class="mb-3"
            action="/activityapi/uploadimage"
            :http-request="uploadImageRequest"
            :show-file-list="false"
            accept="image/jpeg,image/png,image/webp"
            :before-upload="beforeImageUpload"
            :on-success="onImageUploaded"
            :on-error="onImageUploadError"
        >
            <el-button type="primary" size="small">Upload image</el-button>
            <template #tip>
                <div class="el-upload__tip">JPG, PNG, or WEBP. Maximum 5 MB. An activity can have 0 to 2 images.</div>
            </template>
        </el-upload>
        <el-form label-position="top" size="small">
            <el-form-item label="Image URL">
                <el-input v-model="imageDraft" placeholder="https://..." />
            </el-form-item>
        </el-form>
        <template #footer>
            <div class="dialog-footer">
                <el-button @click="imageDialog = false">Cancel</el-button>
                <el-button type="primary" @click="saveImageDraft">Save</el-button>
            </div>
        </template>
    </el-dialog>
</template>

<style scoped>
.activity-images {
    padding: 0 8px 12px;
}
.activity-images-head {
    margin-bottom: 8px;
}
.activity-images-row {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    align-items: flex-end;
}
.activity-image-card img,
.activity-image-preview img {
    width: 160px;
    height: 96px;
    object-fit: cover;
    border-radius: 4px;
    border: 1px solid #ebeef5;
    display: block;
    background: #f5f7fa;
}
.activity-image-actions {
    display: flex;
    gap: 6px;
    margin-top: 6px;
}
.activity-image-preview {
    margin-bottom: 12px;
}
</style>
